export default __webpack_public_path__ + "static/media/step3-4.74883755.jpg";